import { Link } from "react-router-dom";
import { useLang } from "../lang";
import { groups, products } from "../data";

export function ProductCard({ p }) {
  const { t } = useLang();
  return (
    <article className="flex flex-col overflow-hidden rounded-lg border border-steel-200 bg-white">
      <div className="relative aspect-[4/3] bg-steel-100">
        <img src={p.img} alt={t(p.name)} loading="lazy" className="absolute inset-0 h-full w-full object-cover" />
        {p.sample && (
          <span className="absolute bottom-2 left-2 rounded bg-black/60 px-2 py-0.5 text-xs text-white">
            {t("ภาพตัวอย่าง", "Sample photo")}
          </span>
        )}
      </div>
      <div className="flex flex-1 flex-col p-5">
        <h3 className="text-lg font-semibold">{t(p.name)}</h3>
        <p className="mt-2 text-ink-soft">{t(p.des)}</p>
      </div>
    </article>
  );
}

function Productpage() {
  const { t } = useLang();
  return (
    <>
      <section className="border-b border-steel-200 bg-white">
        <div className="wrap py-12 md:py-16">
          <h1 className="text-3xl font-bold md:text-5xl">{t("งานระบบและผลิตภัณฑ์", "Systems & products")}</h1>
          <p className="mt-4 max-w-3xl text-lg text-ink-soft">
            {t(
              "รับออกแบบ ผลิต และติดตั้งระบบสายพานลำเลียงและเครื่องจักรอัตโนมัติทุกขนาด ให้คำปรึกษาเรื่องรูปแบบ รุ่น และวัสดุให้เหมาะกับสินค้าและกำลังการผลิตของลูกค้า รวมถึงระบบไฟ ตู้คอนโทรล และรางไฟภายในโรงงาน",
              "We design, build and install conveyors and automated machines of every size, and advise on layout, models and materials to suit your product and output, plus the electrical systems, control cabinets and cable trays around them."
            )}
          </p>
          <nav className="mt-6 flex flex-wrap gap-2" aria-label={t("หมวดสินค้า", "Categories")}>
            {groups.map((g) => (
              <a key={g.id} href={`#${g.id}`} className="rounded-full border border-steel-200 px-4 py-1.5 text-sm font-medium hover:border-gws-blue hover:text-gws-blue">
                {t(g.name)}
              </a>
            ))}
          </nav>
        </div>
      </section>

      {groups.map((g) => (
        <section key={g.id} id={g.id} className="wrap scroll-mt-20 py-12">
          <h2 className="mb-6 text-2xl font-bold md:text-3xl">{t(g.name)}</h2>
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {products.filter((p) => p.group === g.id).map((p) => <ProductCard key={p.id} p={p} />)}
          </div>
        </section>
      ))}

      <section className="bg-ink text-white">
        <div className="wrap flex flex-col items-start gap-6 py-12 md:flex-row md:items-center md:justify-between">
          <div>
            <p className="text-2xl font-bold">{t("ไม่เจอเครื่องที่ต้องการ?", "Need something not listed?")}</p>
            <p className="mt-1 text-steel-200">{t("งานส่วนใหญ่ของเราเป็นเครื่องสั่งทำ เล่าโจทย์ไลน์ผลิตให้เราฟังได้เลย", "Most of what we build is custom. Tell us about your line.")}</p>
          </div>
          <Link to="/contact" className="btn-primary">{t("ปรึกษาฟรี", "Free consultation")}</Link>
        </div>
      </section>
    </>
  );
}

export default Productpage;
